import { SvgIcon } from "@mui/material";
import React from "react";

const CloseIcon = ({ scale }: { scale?: number }) => {
  return (
    <SvgIcon
      style={{ transform: `scale(${scale || 0.6})` }}
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3337 11.8334L1.66699 1.16675M12.3337 1.16675L1.66699 11.8334"
        stroke="#3D3D3D"
        strokeWidth="2"
        stroke-linecap="round"
      />
    </SvgIcon>
  );
};

export default CloseIcon;
